import React from "react";

const QuickAmountButtons = ({
  isRupeeSelected,
  activeAmount,
  handleAmountButtonClick,
}) => {
  return (
    <div>
      <div className="recommend_btn_container">
        {(isRupeeSelected
          ? ["100", "500", "1000", "5000"]
          : ["1", "2", "3", "4"]
        ).map((amount) => (
          <button
            type="button"
            className={`recommend_btn ${
              activeAmount === amount ? "recommend_btn_active" : ""
            }`}
            key={amount}
            onClick={() => handleAmountButtonClick(amount)}
          >
            {isRupeeSelected ? `₹${amount}` : `${amount}gm`}
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickAmountButtons;
